import {
    USER_PROFILE_DATA_STARTED,
    USER_PROFILE_DATA_SUCCESS,
    USER_PROFILE_DATA_FAILURE,
    USER_PROFILE_AVATAR
} from '../actions/actionTypes';
import config from '../config';
import moment from 'moment';

const initialState = {
    isLoading: false,
    userData: {},
    userAvatar: null,
    error: null
};

export default function userProfileData(state = initialState, action) {
    switch (action.type) {
        case USER_PROFILE_DATA_STARTED:
            return {
                ...state,
                isLoading: true
            };
        case USER_PROFILE_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userData: action.payload.data
            };
        case USER_PROFILE_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case USER_PROFILE_AVATAR:
            return {
                ...state,
                userAvatar: `${config.BACKEND_API_URL}/api/employee/photo/${action.payload}?${moment().valueOf()}`
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userProfileData.js